import { Terms, TileKit } from '@carvana/merch-search';
import type React from 'react';
import { useContext } from 'react';
import FinancingType from '~/constants/FinancingType';
import { useFinanceType } from '~/contexts/FinanceAndTradeContext';
import SearchContext from '~/contexts/SearchContext';
import { useHasActiveTradeApplied } from '~/hooks/selectors';
import Pricing from './Pricing/Pricing';

type PriceAndTermsProps = {
  mappedAnalyticsEvents: {
    trackClickedMonthlyPayment: () => void;
    trackClickedMonthlyPaymentCTA: () => void;
  };
  openSoftPullModal: () => void;
};

const PriceAndTerms: React.VFC<PriceAndTermsProps> = ({
  mappedAnalyticsEvents,
  openSoftPullModal
}) => {
  const hasActiveTradeApplied = useHasActiveTradeApplied();
  const hasValidTerms = useFinanceType() === FinancingType.UserFinancing;
  const { showFinance } = useContext(SearchContext);

  const { trackClickedMonthlyPayment, trackClickedMonthlyPaymentCTA } =
    mappedAnalyticsEvents;

  return (
    <>
      <TileKit.Pane className="middle-frame-pane">
        <Pricing />
      </TileKit.Pane>
      <TileKit.Pane className="middle-frame-pane">
        <Terms
          hasTradeIn={hasActiveTradeApplied}
          hasValidTerms={hasValidTerms}
          hidden={!showFinance}
          openSoftPullModal={openSoftPullModal}
          trackMonthlyPaymentClicked={trackClickedMonthlyPayment}
          trackMonthlyPaymentCTAClicked={trackClickedMonthlyPaymentCTA}
        />
      </TileKit.Pane>
    </>
  );
};

export default PriceAndTerms;
